import { render, staticRenderFns } from "./AIChatTextArea.vue?vue&type=template&id=6812f8ce&scoped=true"
import script from "./AIChatTextArea.vue?vue&type=script&lang=js"
export * from "./AIChatTextArea.vue?vue&type=script&lang=js"
import style0 from "./AIChatTextArea.vue?vue&type=style&index=0&id=6812f8ce&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6812f8ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6812f8ce')) {
      api.createRecord('6812f8ce', component.options)
    } else {
      api.reload('6812f8ce', component.options)
    }
    module.hot.accept("./AIChatTextArea.vue?vue&type=template&id=6812f8ce&scoped=true", function () {
      api.rerender('6812f8ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/AIChatTextArea.vue"
export default component.exports